import axios from "axios";
import { postsSlice, callTypes } from "./postsSlice";

const API_URL = process.env.REACT_APP_API_URL;
const { actions } = postsSlice;

export const fetchPosts = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "posts/all", {
      params: { _limit: -1, _sort: "published_at:DESC" },
    })
    .then((response) => {
      dispatch(actions.postsFetched({ postsList: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};

export const fetchDraftPosts = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "posts/all", {
      params: { _limit: -1, _sort: "published_at:DESC",
      _publicationState: 'preview',
      published_at_null: true },
    })
    .then((response) => {
      dispatch(actions.drafPost({ drafPost: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};

export const hidePost = (postReport) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.hide }));

  const body = {
    reason: postReport.reasons,
    comment: postReport.comments,
    send_pn: postReport.notifications.includes("Send push"),
    send_email: postReport.notifications.includes("Send email"),
  };

  return axios
    .put(API_URL + `posts/${postReport.id}/hide`, body)
    .then((response) => {
      dispatch(actions.postHided({ postHided: response.data }));
    })
    .catch((err) =>
      dispatch(actions.catchError({ error: err, callType: callTypes.hide }))
    );
};

export const createPost = (post) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.hide }));
  return axios
    .post(API_URL + "/posts", post)
    .then((response) => {
      dispatch(actions.postCreated({ newPost: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.hide }));
    });
};

export const updatedDrafPost = (post, postId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.hide }));
  return axios
    .put(API_URL + `/posts/${postId}`, post)
    .then((response) => {
      dispatch(actions.postDraftEdited({ postDraftEdited: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.hide }));
    });
};

export const deletePostById = (postId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.hide }));
  return axios
    .delete(API_URL + `/posts/${postId}`)
    .then((response) => {
      dispatch(actions.deletePost({ postDeleted: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.hide }));
    });
};

export const fetchCategories = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "categories")
    .then((response) => {
      dispatch(actions.categoriesFetched({ categoriesList: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};

export const createPollOnPost = (poll, dispatch) => {
  return dispatch(actions.postPollCreated({ poll: poll }));
};

export const getPostById = async (post, dispatch) => {
  return axios
    .get(API_URL + `/posts/${post}`)
    .then((response) => {
      dispatch(actions.getPost({ fetchPost: response.data.post }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};
